package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets24 {
  internal val names_39_divrei_hayamim_b_29_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_29_txt() }

  internal val names_39_divrei_hayamim_b_30_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_30_txt() }

  internal val names_39_divrei_hayamim_b_31_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_31_txt() }

  internal val names_39_divrei_hayamim_b_32_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_32_txt() }

  internal val names_39_divrei_hayamim_b_33_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_33_txt() }

  internal val names_39_divrei_hayamim_b_34_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_34_txt() }

  internal val names_39_divrei_hayamim_b_35_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_35_txt() }

  internal val names_39_divrei_hayamim_b_36_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_36_txt() }

  internal val names_39_divrei_hayamim_b_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_txt() }

  internal val names_3_vayikra_24_txt: AssetResource by lazy { init_names_3_vayikra_24_txt() }

  internal val names_3_vayikra_txt: AssetResource by lazy { init_names_3_vayikra_txt() }

  internal val names_4_bamidbar_10_txt: AssetResource by lazy { init_names_4_bamidbar_10_txt() }

  internal val names_4_bamidbar_11_txt: AssetResource by lazy { init_names_4_bamidbar_11_txt() }

  internal val names_4_bamidbar_13_txt: AssetResource by lazy { init_names_4_bamidbar_13_txt() }

  internal val names_4_bamidbar_14_txt: AssetResource by lazy { init_names_4_bamidbar_14_txt() }

  internal val names_4_bamidbar_16_txt: AssetResource by lazy { init_names_4_bamidbar_16_txt() }

  internal val names_4_bamidbar_20_txt: AssetResource by lazy { init_names_4_bamidbar_20_txt() }

  internal val names_4_bamidbar_21_txt: AssetResource by lazy { init_names_4_bamidbar_21_txt() }

  internal val names_4_bamidbar_22_txt: AssetResource by lazy { init_names_4_bamidbar_22_txt() }

  internal val names_4_bamidbar_23_txt: AssetResource by lazy { init_names_4_bamidbar_23_txt() }

  internal val names_4_bamidbar_25_txt: AssetResource by lazy { init_names_4_bamidbar_25_txt() }

  internal val names_4_bamidbar_27_txt: AssetResource by lazy { init_names_4_bamidbar_27_txt() }

  internal val names_4_bamidbar_txt: AssetResource by lazy { init_names_4_bamidbar_txt() }

  internal val names_5_devarim_01_txt: AssetResource by lazy { init_names_5_devarim_01_txt() }

  internal val names_5_devarim_03_txt: AssetResource by lazy { init_names_5_devarim_03_txt() }

  internal val names_5_devarim_33_txt: AssetResource by lazy { init_names_5_devarim_33_txt() }

  internal val names_5_devarim_txt: AssetResource by lazy { init_names_5_devarim_txt() }

  internal val names_6_yehoshua_02_txt: AssetResource by lazy { init_names_6_yehoshua_02_txt() }

  internal val names_6_yehoshua_06_txt: AssetResource by lazy { init_names_6_yehoshua_06_txt() }

  internal val names_6_yehoshua_07_txt: AssetResource by lazy { init_names_6_yehoshua_07_txt() }

  internal val names_6_yehoshua_08_txt: AssetResource by lazy { init_names_6_yehoshua_08_txt() }

  internal val names_6_yehoshua_10_txt: AssetResource by lazy { init_names_6_yehoshua_10_txt() }

  internal val names_6_yehoshua_11_txt: AssetResource by lazy { init_names_6_yehoshua_11_txt() }

  internal val names_6_yehoshua_14_txt: AssetResource by lazy { init_names_6_yehoshua_14_txt() }

  internal val names_6_yehoshua_15_txt: AssetResource by lazy { init_names_6_yehoshua_15_txt() }

  internal val names_6_yehoshua_16_txt: AssetResource by lazy { init_names_6_yehoshua_16_txt() }

  internal val names_6_yehoshua_17_txt: AssetResource by lazy { init_names_6_yehoshua_17_txt() }

  internal val names_6_yehoshua_18_txt: AssetResource by lazy { init_names_6_yehoshua_18_txt() }

  internal val names_6_yehoshua_19_txt: AssetResource by lazy { init_names_6_yehoshua_19_txt() }

  internal val names_6_yehoshua_22_txt: AssetResource by lazy { init_names_6_yehoshua_22_txt() }

  internal val names_6_yehoshua_txt: AssetResource by lazy { init_names_6_yehoshua_txt() }

  internal val names_7_shoftim_01_txt: AssetResource by lazy { init_names_7_shoftim_01_txt() }

  internal val names_7_shoftim_02_txt: AssetResource by lazy { init_names_7_shoftim_02_txt() }

  internal val names_7_shoftim_03_txt: AssetResource by lazy { init_names_7_shoftim_03_txt() }

  internal val names_7_shoftim_04_txt: AssetResource by lazy { init_names_7_shoftim_04_txt() }

  internal val names_7_shoftim_05_txt: AssetResource by lazy { init_names_7_shoftim_05_txt() }

  internal val names_7_shoftim_07_txt: AssetResource by lazy { init_names_7_shoftim_07_txt() }

  internal val names_7_shoftim_08_txt: AssetResource by lazy { init_names_7_shoftim_08_txt() }

  internal val names_7_shoftim_09_txt: AssetResource by lazy { init_names_7_shoftim_09_txt() }

  internal val names_7_shoftim_10_txt: AssetResource by lazy { init_names_7_shoftim_10_txt() }

  internal fun values(): List<AssetResource> = listOf(names_39_divrei_hayamim_b_29_txt,
      names_39_divrei_hayamim_b_30_txt, names_39_divrei_hayamim_b_31_txt,
      names_39_divrei_hayamim_b_32_txt, names_39_divrei_hayamim_b_33_txt,
      names_39_divrei_hayamim_b_34_txt, names_39_divrei_hayamim_b_35_txt,
      names_39_divrei_hayamim_b_36_txt, names_39_divrei_hayamim_b_txt, names_3_vayikra_24_txt,
      names_3_vayikra_txt, names_4_bamidbar_10_txt, names_4_bamidbar_11_txt,
      names_4_bamidbar_13_txt, names_4_bamidbar_14_txt, names_4_bamidbar_16_txt,
      names_4_bamidbar_20_txt, names_4_bamidbar_21_txt, names_4_bamidbar_22_txt,
      names_4_bamidbar_23_txt, names_4_bamidbar_25_txt, names_4_bamidbar_27_txt,
      names_4_bamidbar_txt, names_5_devarim_01_txt, names_5_devarim_03_txt, names_5_devarim_33_txt,
      names_5_devarim_txt, names_6_yehoshua_02_txt, names_6_yehoshua_06_txt,
      names_6_yehoshua_07_txt, names_6_yehoshua_08_txt, names_6_yehoshua_10_txt,
      names_6_yehoshua_11_txt, names_6_yehoshua_14_txt, names_6_yehoshua_15_txt,
      names_6_yehoshua_16_txt, names_6_yehoshua_17_txt, names_6_yehoshua_18_txt,
      names_6_yehoshua_19_txt, names_6_yehoshua_22_txt, names_6_yehoshua_txt,
      names_7_shoftim_01_txt, names_7_shoftim_02_txt, names_7_shoftim_03_txt,
      names_7_shoftim_04_txt, names_7_shoftim_05_txt, names_7_shoftim_07_txt,
      names_7_shoftim_08_txt, names_7_shoftim_09_txt, names_7_shoftim_10_txt)
}

private fun init_names_39_divrei_hayamim_b_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-29.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-29.txt")

private fun init_names_39_divrei_hayamim_b_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-30.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-30.txt")

private fun init_names_39_divrei_hayamim_b_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-31.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-31.txt")

private fun init_names_39_divrei_hayamim_b_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-32.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-32.txt")

private fun init_names_39_divrei_hayamim_b_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-33.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-33.txt")

private fun init_names_39_divrei_hayamim_b_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-34.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-34.txt")

private fun init_names_39_divrei_hayamim_b_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-35.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-35.txt")

private fun init_names_39_divrei_hayamim_b_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-36.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-36.txt")

private fun init_names_39_divrei_hayamim_b_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b.txt")

private fun init_names_3_vayikra_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_3_vayikra-24.txt\")") as String, rawPath =
    "peopleNames/names_3_vayikra-24.txt")

private fun init_names_3_vayikra_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_3_vayikra.txt\")") as String, rawPath =
    "peopleNames/names_3_vayikra.txt")

private fun init_names_4_bamidbar_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-10.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-10.txt")

private fun init_names_4_bamidbar_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-11.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-11.txt")

private fun init_names_4_bamidbar_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-13.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-13.txt")

private fun init_names_4_bamidbar_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-14.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-14.txt")

private fun init_names_4_bamidbar_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-16.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-16.txt")

private fun init_names_4_bamidbar_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-20.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-20.txt")

private fun init_names_4_bamidbar_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-21.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-21.txt")

private fun init_names_4_bamidbar_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-22.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-22.txt")

private fun init_names_4_bamidbar_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-23.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-23.txt")

private fun init_names_4_bamidbar_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-25.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-25.txt")

private fun init_names_4_bamidbar_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar-27.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar-27.txt")

private fun init_names_4_bamidbar_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_4_bamidbar.txt\")") as String, rawPath =
    "peopleNames/names_4_bamidbar.txt")

private fun init_names_5_devarim_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_5_devarim-01.txt\")") as String, rawPath =
    "peopleNames/names_5_devarim-01.txt")

private fun init_names_5_devarim_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_5_devarim-03.txt\")") as String, rawPath =
    "peopleNames/names_5_devarim-03.txt")

private fun init_names_5_devarim_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_5_devarim-33.txt\")") as String, rawPath =
    "peopleNames/names_5_devarim-33.txt")

private fun init_names_5_devarim_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_5_devarim.txt\")") as String, rawPath =
    "peopleNames/names_5_devarim.txt")

private fun init_names_6_yehoshua_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-02.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-02.txt")

private fun init_names_6_yehoshua_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-06.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-06.txt")

private fun init_names_6_yehoshua_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-07.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-07.txt")

private fun init_names_6_yehoshua_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-08.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-08.txt")

private fun init_names_6_yehoshua_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-10.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-10.txt")

private fun init_names_6_yehoshua_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-11.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-11.txt")

private fun init_names_6_yehoshua_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-14.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-14.txt")

private fun init_names_6_yehoshua_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-15.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-15.txt")

private fun init_names_6_yehoshua_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-16.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-16.txt")

private fun init_names_6_yehoshua_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-17.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-17.txt")

private fun init_names_6_yehoshua_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-18.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-18.txt")

private fun init_names_6_yehoshua_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-19.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-19.txt")

private fun init_names_6_yehoshua_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua-22.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua-22.txt")

private fun init_names_6_yehoshua_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_6_yehoshua.txt\")") as String, rawPath =
    "peopleNames/names_6_yehoshua.txt")

private fun init_names_7_shoftim_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-01.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-01.txt")

private fun init_names_7_shoftim_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-02.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-02.txt")

private fun init_names_7_shoftim_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-03.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-03.txt")

private fun init_names_7_shoftim_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-04.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-04.txt")

private fun init_names_7_shoftim_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-05.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-05.txt")

private fun init_names_7_shoftim_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-07.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-07.txt")

private fun init_names_7_shoftim_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-08.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-08.txt")

private fun init_names_7_shoftim_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-09.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-09.txt")

private fun init_names_7_shoftim_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_7_shoftim-10.txt\")") as String, rawPath =
    "peopleNames/names_7_shoftim-10.txt")

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_29_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_29_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_30_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_30_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_31_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_31_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_32_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_32_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_33_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_33_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_34_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_34_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_35_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_35_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_36_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_36_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_txt: AssetResource
  get() = CommonMainAssets24.names_39_divrei_hayamim_b_txt

public actual val SharedRes.assets.peopleNames.names_3_vayikra_24_txt: AssetResource
  get() = CommonMainAssets24.names_3_vayikra_24_txt

public actual val SharedRes.assets.peopleNames.names_3_vayikra_txt: AssetResource
  get() = CommonMainAssets24.names_3_vayikra_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_10_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_10_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_11_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_11_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_13_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_13_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_14_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_14_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_16_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_16_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_20_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_20_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_21_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_21_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_22_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_22_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_23_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_23_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_25_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_25_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_27_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_27_txt

public actual val SharedRes.assets.peopleNames.names_4_bamidbar_txt: AssetResource
  get() = CommonMainAssets24.names_4_bamidbar_txt

public actual val SharedRes.assets.peopleNames.names_5_devarim_01_txt: AssetResource
  get() = CommonMainAssets24.names_5_devarim_01_txt

public actual val SharedRes.assets.peopleNames.names_5_devarim_03_txt: AssetResource
  get() = CommonMainAssets24.names_5_devarim_03_txt

public actual val SharedRes.assets.peopleNames.names_5_devarim_33_txt: AssetResource
  get() = CommonMainAssets24.names_5_devarim_33_txt

public actual val SharedRes.assets.peopleNames.names_5_devarim_txt: AssetResource
  get() = CommonMainAssets24.names_5_devarim_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_02_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_02_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_06_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_06_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_07_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_07_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_08_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_08_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_10_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_10_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_11_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_11_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_14_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_14_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_15_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_15_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_16_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_16_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_17_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_17_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_18_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_18_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_19_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_19_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_22_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_22_txt

public actual val SharedRes.assets.peopleNames.names_6_yehoshua_txt: AssetResource
  get() = CommonMainAssets24.names_6_yehoshua_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_01_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_01_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_02_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_02_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_03_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_03_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_04_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_04_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_05_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_05_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_07_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_07_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_08_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_08_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_09_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_09_txt

public actual val SharedRes.assets.peopleNames.names_7_shoftim_10_txt: AssetResource
  get() = CommonMainAssets24.names_7_shoftim_10_txt
